import { createMuiTheme } from '@material-ui/core/styles'

import { colors, fonts, radius, breakpoints } from './tokens'

// The MUI theme is a THIN mirror of the design tokens, not a second source of
// truth. It exists so the MUI components still in use (Dialog, Checkbox,
// Snackbar, Container) pick up the palette, and so `theme.palette.*` inside a
// styles.js reads the real colours.
//
// Everything visual on the home page and the booking screen should come from
// the CSS custom properties in assets/styles/tokens.css, or from
// theme/tokens.js when you are inside JSS. Do not add component overrides
// here for the new sections: style them with the primitives and their
// classes instead (client/gwmc/DESIGN.md).
//
// The old palette (#37b45a green primary, #14a0d1 blue secondary) is gone;
// both are banned by the design direction §4.
export const theme = createMuiTheme({
  breakpoints: { values: { xs: 0, ...breakpoints } },
  palette: {
    primary: {
      main: colors.ink,
      contrastText: colors.onInk
    },
    secondary: {
      main: colors.accent,
      contrastText: colors.onAccent
    },
    error: {
      main: colors.error
    },
    text: {
      primary: colors.ink,
      secondary: colors.mute
    },
    divider: colors.line,
    background: {
      default: colors.paper,
      paper: colors.paper
    }
  },
  typography: {
    fontFamily: fonts.body
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: colors.paper
        }
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: colors.paper
      }
    },
    // The app's own container owns its gutters (see assets/styles/tokens.css
    // --gutter), so MUI's responsive padding is zeroed out.
    MuiContainer: {
      root: {
        paddingLeft: 0,
        paddingRight: 0,
        '@media (min-width: 600px)': {
          paddingLeft: 0,
          paddingRight: 0
        },
        '@media (min-width: 960px)': {
          paddingLeft: 0,
          paddingRight: 0
        },
        '@media (min-width: 1280px)': {
          paddingLeft: 0,
          paddingRight: 0
        }
      }
    },
    MuiCheckbox: {
      colorPrimary: {
        color: colors.mute,
        '&$checked': {
          color: colors.accent
        }
      },
      colorSecondary: {
        color: colors.mute,
        '&$checked': {
          color: colors.accent
        }
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: radius.card
      }
    }
  }
})
